import { styled } from '@mui/material';

import { useState } from 'react';

import { useI18n } from '@app-velocity/i18n';

import { ArrowDownIcon } from '@app-velocity/icons';

import { SingleMetric } from '../../../SingleMetric';

import { useSimulationWidgetContext } from '../../../../hooks/useSimulationWidgetContext';
import { useSingleSimulationMetrics } from '../../../../hooks/useSingleSimulationMetrics';

const Wrapper = styled('div')(({ theme }) => ({
  background: '#fff',
  borderRadius: theme.spacing(2),
}));

const MetricsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'space-around',
  gap: theme.spacing(4),
  flexWrap: 'wrap',
  padding: `${theme.spacing(6)} ${theme.spacing(2)}`,
}));

const RotatedArrow = styled('div')({
  transform: 'rotate(180deg)',
  display: 'flex',
});

const ExpandButton = styled('button')(({ theme }) => ({
  padding: `${theme.spacing(2.5)} ${theme.spacing(4)}`,
  textAlign: 'center',
  fontSize: 11,
  color: 'var(--button-button-secondary-text-color)',
  fontWeight: 500,
  cursor: 'pointer',
  border: 'none',
  borderTop: '1px solid var(--stroke-stroke-primary-color)',
  background: 'transparent',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  svg: {
    fill: 'var(--button-button-secondary-text-color)',
    height: theme.spacing(3),
    width: theme.spacing(3),
  },
}));

export const SimulationMetrics = () => {
  const { t } = useI18n();
  const { latestReview, statistics, parsedStatus, config } =
    useSimulationWidgetContext();

  const [expanded, setExpanded] = useState(false);

  const { metrics } = useSingleSimulationMetrics(statistics, config);

  const toggle = () => {
    setExpanded((prev) => !prev);
  };

  if (
    !parsedStatus ||
    !latestReview ||
    latestReview.reviewStatus === 'IN_PROGRESS' ||
    !metrics ||
    metrics.length === 0
  )
    return null;

  const slicedMetrics = expanded ? metrics : metrics.slice(0, 2);

  return (
    <Wrapper>
      <MetricsContainer>
        {slicedMetrics.map((metric, index) => (
          <SingleMetric key={index} {...metric} />
        ))}
      </MetricsContainer>
      <ExpandButton onClick={toggle}>
        {expanded ? (
          <>
            {t('prototypes:report.metric.show_less')} <ArrowDownIcon />
          </>
        ) : (
          <>
            {t('prototypes:report.metric.more_metrics')}{' '}
            <RotatedArrow>
              <ArrowDownIcon />
            </RotatedArrow>
          </>
        )}
      </ExpandButton>
    </Wrapper>
  );
};
